import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import uiRouter from '@uirouter/angularjs';
import routing from './disclosure.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';
import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

export class DisclosureController {

  constructor (notifier, $state, $log, $sce, iceApplicationPreferences, LmrcApiService, queryParamGetter) {
    'ngInject';
    this._logger = $log.getInstance('ContactInfoController');
    this.notifier = notifier;
    this._$state = $state;
    this._queryParamGetter = queryParamGetter;
    this._lmrcApiService = LmrcApiService;
    this._iceApplicationPreferences = iceApplicationPreferences;
    this._$sce = $sce;
    this.data={
      generalCondition: false,
      usageCondition: false,
      commercialAgreement: true,
      thirdPartyAgreement: true
    };
  }

  $onInit() {
    this.usageConditionUrl = this._iceApplicationPreferences.getPref('features.disclosure.usage-condition-url');
    this.usageConditionUrl = this._$sce.trustAsResourceUrl(this.usageConditionUrl);

    this.generalConditionUrl = this._iceApplicationPreferences.getPref('features.disclosure.general-condition-url');
    this.generalConditionUrl = this._$sce.trustAsResourceUrl(this.generalConditionUrl);

    this.privacyPolicyUrl = this._iceApplicationPreferences.getPref('features.disclosure.privacy-policy-url');
    this.privacyPolicyUrl = this._$sce.trustAsResourceUrl(this.privacyPolicyUrl);
    this._logger.debug("INITIALIZING")
    const customizationId = _.trim(this._queryParamGetter('ui', true));
    if (customizationId) {
      const that = this;
      this._lmrcApiService.getCustomization(customizationId)
        .then(resp => {
          that. _logger.debug("getCustomization response", resp.data);
          // {
          //   "externalDomain": "gmail.com",
          //   "customCss": null,
          //   "logoPath": null,
          //   "skipTermsAndConditionsPhase": false,
          //   "termsOfServicePath": null,
          //   "conditionContractPath": null,
          //   "privacyPolicyPath": null
          // }
          if (resp.data.termsOfServicePath) {
            that._logger.debug("getCustomization setting termsOfService", resp.data.termsOfServicePath);
            that.usageConditionUrl = resp.data.termsOfServicePath;
            that._logger.debug("termsOfServicePath CHANGED")
          }
          if (resp.data.conditionContractPath) {
            that._logger.debug("getCustomization setting conditionContract", resp.data.conditionContractPath);
            that.generalConditionUrl = resp.data.conditionContractPath;
            that._logger.debug("conditionContractPath CHANGED")
          }
          if (resp.data.privacyPolicyPath) {
            that._logger.debug("getCustomization setting privacyPolicy", resp.data.privacyPolicyPath);
            that.privacyPolicyUrl = resp.data.privacyPolicyPath;
            that._logger.debug("privacyPolicyPath CHANGED")
          }
        }, err => {
          that._logger.debug("getCustomization failed, using default conf", err);
        });
    } else{
      _logger.debug("getCustomization no customization")
    }
    this._logger.debug("INITIALIZED")
  }

  updateUserAgreements(formValid){
    if(formValid){
      this.loading = true;
      this._logger.debug("user agreements data", this.data);
      this._lmrcApiService.updateUserAgreements(this.data).then(() => {
        this.loading = false;
        this._logger.debug("go to external.pec-import");
        this._$state.go("external.pec-import");
      }, (err) => {
        this.loading = false;
        this._logger.debug("updateUserAgreements failed", err);
        this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
      });
    }
  }
}

export default angular.module('lmrcApp.disclosure', [
  uiRouter,
  ngSanitize,
  translateModule,

  feconClientBundle,

  util,
  api

])
  .config(routing)
  .component('disclosure', {
    template: require('./disclosure.html'),
    controller: DisclosureController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/features/disclosure/index.js